/*
	namespace: String
	initialState: {
		table: TablePropType
	}
	stateNodeName: String
*/
export function createTable({
	namespace,
	initialState,
	stateNodeName = 'table'
}) {
	// actions
	const actions =  {};

	// reducers
	const reducers = {};

	// selectors
	const selectors = {
		getTable: state => {
			const { [stateNodeName]: tableState, data } = state[namespace];
			return { ...tableState, rows: data || [] };
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
}

/*
	namespace: String
	initialState: {
		table: TablePropType
		sortedBy: {
			[key]: {
				index: String (column.index)
				direction: String (asc/desc)
			}
		}
	}
	stateNodeName: String
	sortingConfig: {
		sort: Function
	}
*/
export function createTableWithSorting({
	namespace,
	initialState,
	stateNodeName = 'table',
	sortingConfig
}) {
	const table = createTable({ namespace, initialState, stateNodeName });

	// action types
	const CHANGE_DIRECTION = `${namespace}/${stateNodeName}/change-direction`;

	// actions
	const actions =  {
		...table.actions,
		sort: ({ index, header }) => (dispatch, getState) => {
			dispatch({
				type: CHANGE_DIRECTION,
				payload: { index, header }
			});

			dispatch(sortingConfig.sort(header.sorting.remote));
		}
	};

	// reducers
	const reducers = {
		...table.reducers,
		[CHANGE_DIRECTION]: (state, action) => {
			const { index, header } = action.payload;

			const tableState = state[stateNodeName];

			const sortedByData = tableState.sortedBy[header.sorting.key];

			const direction = sortedByData.index === index
				? sortedByData.direction === 'desc' ? 'asc' : 'desc'
				: header.sorting.direction;

			return {
				...state,
				[stateNodeName]: {
					...tableState,
					sortedBy: {
						...tableState.sortedBy,
						[header.sorting.key]: {
							index,
							direction
						}
					}
				}
			};
		}
	};

	// selectors
	const selectors = { ...table.selectors };

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
}


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/new-table/index.js